import React from "react";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";
import { Drawer, Button } from "@material-ui/core";
import _ from "lodash";
import { ReactComponent as DownArrow } from "../../../images/down_arrow.svg";
import * as action from "../../../redux/actions/actions";
import * as commonMethod from "../../../commonMethods";
import { ReactComponent as SendIcon } from "../../../images/send_blk.svg";
import { ReactComponent as EditImage } from "../../../images/edit.svg";
import { ReactComponent as DeleteImage } from "../../../images/trash2.svg";
import { ReactComponent as AddToGroupIcon } from "../../../images/group-add-icon.svg";
import { ReactComponent as DotsIcon } from "../../../images/wht_dots.svg";
import { ReactComponent as BackIcon } from "../../../images/left_arrow.svg";
import { ReactComponent as ErrorIcon } from "../../../images/eroor.svg";
import { Select } from "antd";
import { Collapse } from "antd";
import parsePhoneNumber from 'libphonenumber-js'
import InputMask from "react-input-mask";
import SendMessagePopup from "./sendMessagePopup"
import { store } from "../../../..";

const { Panel } = Collapse;
class ContactOpen extends React.Component<any, any> {
  reactTags: any;
  constructor(props: any) {
    super(props);
    let temporarySharedWith: any;
    this.reactTags = React.createRef();
    this.state = {
      emailErrors: false,
      dialogBox: "",
      sharedWith: "",
      temporarySharedWith,
      phoneNumber: "",
      firstName: "",
      lastName: "",
      list_Id: "",
      email: "",
      contactId: "",
      displayname: "",
      activebutton: false,
      showError: "",
      showErrors: false,
      nameErrors: false,
      SendMessageEmail: "",
      mask: "",
      PhoneNumber: "",
      sharedWithEmail: "",
      sharedWithUserName: "",
      isContainWord: false,
      maskValue: null,
      sharedInboxChange: false,
      contactOwner:"",
    };
  }

  componentDidMount() {
    let contact = this.props.contactSelected_OpenContact;
    let phoneNumber;
    let firstName;
    let lastName;
    let email;
    let sharedWith: any;
    let contactOwner:any;
    let contactId = "";
    let displayname;
    let SendMessageEmail = this.props.sharedinboxData?.currentSelected?.email;
    if (contact.type === "YakChat") {
      var phoneNumberDisplay = '';
      if (contact.hasOwnProperty("PhoneNumber")) {
      var number = (contact.PhoneNumber !== null || contact.PhoneNumber !== undefined) ? contact.PhoneNumber.startsWith('+') ? contact.PhoneNumber : '+' + contact.PhoneNumber : "";
      const parseNumber = parsePhoneNumber(number);
      phoneNumberDisplay=parseNumber !== undefined ?parseNumber.countryCallingCode == this.props.loggedInUserDefaultCountryCode ? (this.props.loggedInUserDefaultCountryCode === 44 || this.props.loggedInUserDefaultCountryCode ===61)?'0'+parseNumber.nationalNumber:parseNumber.nationalNumber: parseNumber?.number: contact.PhoneNumber;
      }
      phoneNumber = phoneNumberDisplay;
      firstName = contact.ForeName;
      lastName = contact.SureName;
      email = contact.ContactEmail;
      displayname = contact.ForeName + " " + (lastName!=null&&lastName!=undefined?lastName:"");
      let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
        {
      sharedWith = this.props.yakChatGroupData && this.props.yakChatGroupData.find((x: any) => x?.InboxId == contact.InboxId) ? this.props.yakChatGroupData.find((x: any) => x?.InboxId == contact.InboxId).Name : contact.GroupEmail;
        }
        else
        {
      sharedWith = this.props.yakChatGroupData && this.props.yakChatGroupData.find((x: any) => x?.Email == contact.GroupEmail) ? this.props.yakChatGroupData.find((x: any) => x?.Email == contact.GroupEmail).UserName : contact.GroupEmail;}
      contactId = contact.ContactId;
      if(sharedWith)
      { 
        if(sharedWith !=="\"\"") contactOwner = contact.UserEmail??"";       
          else contactOwner="";       
      }
      else contactOwner="";
    } else if (contact.type === "Share Point") {
      var number = (contact.mobilePhone !== null && contact.mobilePhone !== undefined) ? contact?.mobilePhone?.startsWith('+') ? contact.mobilePhone : '+' + contact.mobilePhone : "";
      const parseNumber = parsePhoneNumber(number);
      phoneNumber = parseNumber !== undefined ? parseNumber.nationalNumber : contact.mobilePhone;
      firstName = contact.displayName;
      lastName = contact.title;
      email = contact.mail ? contact.mail : "";
      contactId = contact.id;
    } else if (contact.type === "Users") {
      var number = (contact.mobilePhone !== null && contact.mobilePhone !== undefined) ? contact?.mobilePhone?.startsWith('+') ? contact.mobilePhone : '+' + contact.mobilePhone : "";
      const parseNumber = parsePhoneNumber(number);
      phoneNumber = parseNumber !== undefined ? parseNumber.nationalNumber : contact.mobilePhone;
      firstName = contact.givenName;
      lastName = contact.surname;
      email = contact.mail;
      contactId = contact.id;
    } else if (contact.type === "Outlook") {
      var number = (contact?.mobilePhone !== null && contact?.mobilePhone !== undefined) ? contact?.mobilePhone?.startsWith('+') ? contact.mobilePhone : '+' + contact.mobilePhone : "";
      const parseNumber = parsePhoneNumber(number);
      phoneNumber = parseNumber !== undefined ? parseNumber.nationalNumber : contact.mobilePhone;
      firstName = contact.givenName;
      lastName = contact.surname;
      email = contact.emailAddresses[0]?.address;
      contactId = contact.id;
    }
    this.setState({ PhoneNumber: phoneNumber, phoneNumber, firstName, lastName, email, sharedWith, contactId, displayname, SendMessageEmail, editing: this.props.editing,contactOwner:contactOwner });
    if (this.props.loggedInUserDefaultCountryCode === 1) {
      this.setState({ maskValue: ("(999) 999-9999") })
      if (this.state?.phoneNumber?.startsWith("+44")) {
        this.setState({ maskValue: ("09999 999999") });
      } else if (this.state?.phoneNumber?.startsWith("+61")) {
        this.setState({ maskValue: ("09 9999 9999") });
      }
    } else if (this.props.loggedInUserDefaultCountryCode === 44) {
      this.setState({ maskValue: ("09999 999999") });
      if (this.state?.phoneNumber?.startsWith("+1")) {
        this.setState({ maskValue: ("(999) 999-9999") })
      } else if (this.state?.phoneNumber?.startsWith("+61")) {
        this.setState({ maskValue: ("09 9999 9999") });
      }
      if (this.state?.PhoneNumber?.startsWith("+44")) {
        this.setState({ maskValue: ("09999 999999") });
      }
    } else if (this.props.loggedInUserDefaultCountryCode === 61) {
      this.setState({ maskValue: ("09 9999 9999") });
      if (this.state?.phoneNumber?.startsWith("+1")) {
        this.setState({ maskValue: ("(999) 999-9999") })
      } else if (this.state?.phoneNumber?.startsWith("+44")) {
        this.setState({ maskValue: ("09999 999999") });
      }
    } else {
      this.setState({ maskValue: null });
    }
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    let toReturn: any = {};
    let contact = nextProps.contactSelected_OpenContact;
    const id = contact && contact[contact.type == "YakChat" ? "ContactId" : "id"];
    if (id !== prevState.contactId || nextProps.editing !== prevState.editing) {
      let phoneNumber;
      let firstName;
      let lastName;
      let email;
      let sharedWith: any;
      let contactOwner:any;
      let contactId = "";
      let displayname;
      if (contact.type === "YakChat") {
        var contactNumber = '';
        if (contact.hasOwnProperty("PhoneNumber")) {
          
          if( contact.PhoneNumber !== null )
         { contact?.PhoneNumber?.replace(/[^0-9+]+/g)
          var number = contact.PhoneNumber !== null ? contact?.PhoneNumber?.startsWith('+') ? contact.PhoneNumber : '+' + contact.PhoneNumber : "";
          const parseNumber = parsePhoneNumber(number);
          var phoneNumberDisplay = parseNumber !== undefined ? parseNumber.countryCallingCode == nextProps.loggedInUserDefaultCountryCode ? (nextProps.loggedInUserDefaultCountryCode === 44 || nextProps.loggedInUserDefaultCountryCode === 61) ? '0' + parseNumber.nationalNumber : parseNumber.nationalNumber : parseNumber?.number : contact.PhoneNumber;
        } 
          contactNumber = phoneNumberDisplay;   
        }
        phoneNumber = contactNumber;
        firstName = contact.ForeName;
        lastName = contact.SureName;
        email = contact.ContactEmail;
        displayname = contact.ForeName + " " + (lastName!=null&&lastName!=undefined?lastName:"");
        let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
        {
        sharedWith = nextProps.yakChatGroupData && nextProps.yakChatGroupData.find((x: any) => x?.InboxId == contact.InboxId) ? nextProps.yakChatGroupData.find((x: any) => x?.InboxId == contact.InboxId).Name : contact.GroupEmail;
        }
        else
        {
        sharedWith = nextProps.yakChatGroupData && nextProps.yakChatGroupData.find((x: any) => x?.Email == contact.GroupEmail) ? nextProps.yakChatGroupData.find((x: any) => x?.Email == contact.GroupEmail).UserName : contact.GroupEmail;
        }
        contactId = contact.ContactId;
        if(sharedWith)
        { 
          if(sharedWith !=="\"\"")
          {
            contactOwner = contact.UserEmail??"";
          }
          else contactOwner="";
         
        }
        else contactOwner="";

      } else if (contact.type === "Share Point") {
        var number = (contact.mobilePhone !== null && contact.mobilePhone !== undefined) ? contact?.mobilePhone?.startsWith('+') ? contact.mobilePhone : '+' + contact.mobilePhone : "";
        const parseNumber = parsePhoneNumber(number);
        var countryCode = parseNumber !== undefined ? parseNumber.countryCallingCode : ""

        if (countryCode === "1" || countryCode === "61" || countryCode === "44") {
          if (parseNumber)
            phoneNumber = parseNumber.nationalNumber
        } else {
          phoneNumber = contact.mobilePhone
        }
        // phoneNumber = parseNumber !== undefined ? parseNumber.nationalNumber : contact.mobilePhone;
        firstName = contact.displayName;
        lastName = contact.title;
        email = contact.mail ? contact.mail : "";
        contactId = contact.id;
      } else if (contact.type === "Users") {
        var number = (contact.mobilePhone !== null && contact.mobilePhone !== undefined) ? contact?.mobilePhone?.startsWith('+') ? contact.mobilePhone : '+' + contact.mobilePhone : "";
        const parseNumber = parsePhoneNumber(number);
        var countryCode = parseNumber !== undefined ? parseNumber.countryCallingCode : ""

        if (countryCode === "1" || countryCode === "61" || countryCode === "44") {
          if (parseNumber)
            phoneNumber = parseNumber.nationalNumber
        } else {
          phoneNumber = contact.mobilePhone
        }

        firstName = contact.givenName;
        lastName = contact.surname;
        email = contact.mail;
        contactId = contact.id;
      } else if (contact.type === "Outlook") {

        var number = (contact.mobilePhone !== null && contact.mobilePhone !== undefined) ? contact?.mobilePhone?.startsWith('+') ? contact.mobilePhone : '+' + contact.mobilePhone : "";
        const parseNumber = parsePhoneNumber(number);

        var countryCode = parseNumber !== undefined ? parseNumber.countryCallingCode : ""

        //if (countryCode === "1" || countryCode === "61" || countryCode === "44") {
        //added by Maksud
        if (countryCode === "1") {
          if (parseNumber)
            phoneNumber = parseNumber.nationalNumber
        } else {
          phoneNumber = contact.mobilePhone
        }
        // phoneNumber = parseNumber !== undefined ? parseNumber.countryCallingCode !== "1" ? contact.mobilePhone : parseNumber.countryCallingCode !== "44" ? contact.mobilePhone :  parseNumber.countryCallingCode !== "61" ? contact.mobilePhone : parseNumber.nationalNumber : contact.mobilePhone;
        firstName = contact.givenName;
        lastName = contact.surname;
        email = contact.emailAddresses[0]?.address;
        contactId = contact.id;
      }
      toReturn = {
        ...toReturn,
        PhoneNumber: phoneNumber || "",
        phoneNumber: phoneNumber || "",
        firstName: firstName || "",
        lastName: lastName  || "",
        email: email || "",
        sharedWith: sharedWith,
        contactOwner:contactOwner||"",
        contactId: contactId || "",
        editing: nextProps.editing,
        displayname: displayname,
      };
    }
    return toReturn;
  }
  maskValue = (value: any) => {
    if (this.props.loggedInUserDefaultCountryCode === 1) {
      this.state?.PhoneNumber?.startsWith("+1")
      //  value.substring(1)
      this.setState({ maskValue: ("(999) 999-9999") });
    } else if (this.props.loggedInUserDefaultCountryCode === 44) {
      this.setState({ maskValue: ("09999 999999") });
    } else if (this.props.loggedInUserDefaultCountryCode === 61) {
      this.setState({ maskValue: ("09 9999 9999") });
    }
  }
  deleteContact = () => {
    
    var index = this.props.yakchatList.findIndex((x: any) => x.ContactId == this.props.contactSelected_OpenContact.ContactId
    );
    var nextContactId = this.props.yakchatList[index + 1];
    console.log(this.props.yakchatLists);
    
    this.props.deleteThisContact(this.props.contactSelected_OpenContact, nextContactId);
    // if(index+1 !== undefined){
    //   this.props.setContactSelected_OpenContact(this.props.yakchatList[index+1],"");
    // } 
    this.setState({ dialogBox: "" })
  }
  SendMessage = () => {
    ;
    var list = [];
    var SharedInboxemail = this.props.sharedinboxData.currentSelected.email;
    list.push(this.props.contactSelected_OpenContact)
    this.props.sendmessage(list, "", SharedInboxemail);
  };
  handleSharedWith = (e: any) => {
    if (e.target.value === "") {
      this.setState({ sharedWith: this.state.selectedItems })
    } else {
      this.setState({ sharedWith: e.target.value })
    }
  }
  SendMessageBySingleSharedInbox = () => {
    var SharedInboxemail = this.props.sharedinboxData.currentSelected.email;
    // var SharedInboxemail = localStorage.getItem("SharedInboxemail");
    var list = [];
    list.push(this.props.contactSelected_OpenContact);
    this.props.sendmessage(list, "", SharedInboxemail);
  };
  SendMessageToContact = (email: any) => {
    var list = [];
    list.push(this.props.contactSelected_OpenContact)
    if (this.props.sharedinboxData !== undefined && this.props.sharedinboxData?.other?.length > 0) {
      var Getselectedinbox = this.props.sharedinboxData?.other.filter((x: any) => x.email === email);
      if (Getselectedinbox?.length > 0) {
        if (this.props.sharedinboxData?.currentSelected?.email !== email) {
          this.props.CurrentSelectInbox(Getselectedinbox[0])
        }
        this.props.sendmessage(list, "", Getselectedinbox[0].email);
      } else {
        if (this.props.sharedinboxData?.currentSelected?.email !== email) {
          this.props.CurrentSelectInbox(this.props.sharedinboxData?.currentSelected)
        }
        this.props.sendmessage(list, "", this.props.sharedinboxData?.currentSelected.email);
      }
    }
  }

  //first name Validate

  handleInput = (e: any) => {
    this.setState({ firstName: e.target.value });
    var isNamevalid = e.target.value;
    if (isNamevalid === "") {
      e.preventDefault();
      this.setState({ nameErrors: true });
    } else {
      e.preventDefault();
      this.setState({ nameErrors: false });
    }
  };
  handleChange = (selectedItems: any) => {
    this.setState({ sharedInboxChange: true })
    let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
        {
          let savedEmail = this.props.yakChatGroupData.find((c: any) => { if (c.InboxId === selectedItems[0]) { return (c.Name) } })
    this.setState({ selectedItems });
    this.setState({ sharedWith: selectedItems[0] })
    if (savedEmail !== undefined) { this.setState({ sharedWithEmail: savedEmail.Name }); }
        }
        else
        {
    let savedEmail = this.props.yakChatGroupData.find((c: any) => { if (c.UserName === selectedItems[0]) { return (c.Email) } })
    this.setState({ selectedItems });
    this.setState({ sharedWith: selectedItems[0] })
    if (savedEmail !== undefined) { this.setState({ sharedWithEmail: savedEmail.Email }); }
        }
  };
  saveContact = () => {
    
    if (this.props.contactSelected_OpenContact.type === "Outlook") {
      this.props.editOutLookContact(this.props.contactSelected_OpenContact.id, {
        givenName: this.state.firstName ? this.state.firstName : "",
        surName: this.state.lastName ? this.state.lastName : "",
        mobilePhone: this.state.phoneNumber ? this.state.phoneNumber : "",
        emailAddresses: [{
          address: this.state.email ? this.state.email : "",
          name: this.state.email ? this.state.email : "",
        }],
      });
    } else if (this.props.contactSelected_OpenContact.type === "Users") {
      this.props.editAzureUsers(this.props.contactSelected_OpenContact.id, {
        givenName: this.state.firstName ? this.state.firstName : "",
        surname: this.state.lastName ? this.state.lastName : "",
        mobilePhone: this.state.phoneNumber ? this.state.phoneNumber : "",
        mail: this.state.email ? this.state.email : "",
        displayName: (this.state.firstName ? this.state.firstName : "") + " " + (this.state.lastName ? this.state.lastName : ""),
      });
    } else if (this.props.contactSelected_OpenContact.type === "Share Point") {
      this.props.editSharePointContact({ itemId: this.props.contactSelected_OpenContact.id, listId: this.props.contactSelected_OpenContact.listId, },
        {
          fields: {
            FirstName: this.state.firstName ? this.state.firstName : "",
            Title: this.state.lastName ? this.state.lastName : "",
            FullName: (this.state.firstName ? this.state.firstName : "") + " " + (this.state.lastName ? this.state.lastName : ""),
            WorkPhone: this.state.phoneNumber ? this.state.phoneNumber : "",
          },
        }
      );
    } else if (this.props.contactSelected_OpenContact.type === "YakChat") {
      var isNamevalid = this.state.firstName ? this.state.firstName : "";
      if (isNamevalid === "") {this.setState({ nameErrors: true }); }
       else { this.setState({ nameErrors: false }); };
      var isvalid = this.state.phoneNumber ? this.state.phoneNumber : "";
      if (isvalid === "") {
        // e.preventDefault();
        this.setState({ showError: "Please enter a valid phone number", showErrors: true });
        return;
      } else {
        this.setState({ showErrors: false });
      }
      if (this.state.isContainWord === true) {
        this.setState({ showError: "Please enter a valid phone number", showErrors: true });
      } else {
        this.setState({ showErrors: false });
      }
      if (isNamevalid && !this.state.emailErrors && isvalid !== "" && this.state.isContainWord !== true) {
        var unChangedGroupEmail = this.props.contactSelected_OpenContact.GroupEmail !== undefined ? this.props.contactSelected_OpenContact.GroupEmail : "";
        setTimeout(() => {
          this.props.editYakChatContact(this.props.contactSelected_OpenContact.ContactId, {
            foreName: this.state.firstName ? this.state.firstName : "",
            surename: (this.state.lastName!=null&&this.state.lastName!=undefined?this.state.lastName:""),
            Phone: this.state.phoneNumber ? this.state.phoneNumber : "",
            Email: this.state.email ? this.state.email : "",
            ownerEmail:this.props.contactSelected_OpenContact.UserEmail,
            groupEmail: this.state.sharedInboxChange ? this.state.sharedWithEmail : unChangedGroupEmail
          });
        }, 100);
      }
    }
  };
  validatePhoneNumber = (e: any) => {
    var phoneNumber = e.target.value;
    this.setState({ PhoneNumber: phoneNumber })
    var regExp = /[a-zA-Z]/g
    let isnum = regExp.test(phoneNumber);
    if (phoneNumber?.startsWith("+61") || phoneNumber?.startsWith("44")) {
      if (phoneNumber?.length === 10) {
        phoneNumber = phoneNumber?.substring(3);
      }
    } else if (phoneNumber?.startsWith("+1")) {
      if (phoneNumber?.length === 10) {
        phoneNumber = phoneNumber?.substring(2);
      }
    }
    if (phoneNumber?.length === 12) {
      if (phoneNumber?.startsWith("+1")) {
        phoneNumber = phoneNumber?.substring(2);
        this.maskValue(phoneNumber);
      }
    }
    if (phoneNumber?.length === 10) {
      if (phoneNumber?.startsWith("+61") || phoneNumber?.startsWith("+44")) {
        this.maskValue(phoneNumber);
      }
    }
    if (isnum === true) {
      this.setState({ PhoneNumber: phoneNumber, isContainWord: true });
      return phoneNumber;
    } else {
      this.setState({ isContainWord: false });
    }
    if (phoneNumber?.length === 12) {
      if (phoneNumber?.startsWith("+1")) {
        phoneNumber = phoneNumber?.substring(2);
        this.maskValue(phoneNumber);
        this.maskValue(phoneNumber);
      }
    }
    const JSONMappingData = '{"93":"AF","358":"AX","355":"AL","213":"DZ","1684":"AS","376":"AD","244":"AO","1264":"AI","1268":"AG","54":"AR","374":"AM","297":"AW","61":"AU","43":"AT","994":"AZ","1242":"BS","973":"BH","880":"BD","1246":"BB","375":"BY","32":"BE","501":"BZ","229":"BJ","1441":"BM","975":"BT","591":"BO","5997":"BQ","387":"BA","267":"BW","55":"BR","246":"IO","1284":"VG","673":"BN","359":"BG","226":"BF","257":"BI","855":"KH","237":"CM","1":"CA","238":"CV","1345":"KY","236":"CF","235":"TD","56":"CL","86":"CN","61":"CX","61":"CC","57":"CO","269":"KM","242":"CG","243":"CD","682":"CK","506":"CR","385":"HR","53":"CU","599":"CW","357":"CY","420":"CZ","45":"DK","253":"DJ","1767":"DM","1809":"DO","593":"EC","20":"EG","503":"SV","240":"GQ","291":"ER","372":"EE","251":"ET","500":"FK","298":"FO","679":"FJ","358":"FI","33":"FR","594":"GF","689":"PF","241":"GA","220":"GM","995":"GE","49":"DE","233":"GH","350":"GI","30":"GR","299":"GL","1473":"GD","590":"GP","1671":"GU","502":"GT","44":"GG","224":"GN","245":"GW","592":"GY","509":"HT","379":"VA","504":"HN","852":"HK","36":"HU","354":"IS","91":"IN","62":"ID","225":"CI","98":"IR","964":"IQ","353":"IE","44":"IM","972":"IL","39":"IT","1876":"JM","81":"JP","44":"JE","962":"JO","76":"KZ","254":"KE","686":"KI","965":"KW","996":"KG","856":"LA","371":"LV","961":"LB","266":"LS","231":"LR","218":"LY","423":"LI","370":"LT","352":"LU","853":"MO","389":"MK","261":"MG","265":"MW","60":"MY","960":"MV","223":"ML","356":"MT","692":"MH","596":"MQ","222":"MR","230":"MU","262":"YT","52":"MX","691":"FM","373":"MD","377":"MC","976":"MN","382":"ME","1664":"MS","212":"MA","258":"MZ","95":"MM","264":"NA","674":"NR","977":"NP","31":"NL","687":"NC","64":"NZ","505":"NI","227":"NE","234":"NG","683":"NU","672":"NF","850":"KP","1670":"MP","47":"NO","968":"OM","92":"PK","680":"PW","970":"PS","507":"PA","675":"PG","595":"PY","51":"PE","63":"PH","64":"PN","48":"PL","351":"PT","1787":"PR","974":"QA","383":"XK","262":"RE","40":"RO","7":"RU","250":"RW","590":"BL","290":"SH","1869":"KN","1758":"LC","590":"MF","508":"PM","1784":"VC","685":"WS","378":"SM","239":"ST","966":"SA","221":"SN","381":"RS","248":"SC","232":"SL","65":"SG","1721":"SX","421":"SK","386":"SI","677":"SB","252":"SO","27":"ZA","500":"GS","82":"KR","211":"SS","34":"ES","94":"LK","249":"SD","597":"SR","4779":"SJ","268":"SZ","46":"SE","41":"CH","963":"SY","886":"TW","992":"TJ","255":"TZ","66":"TH","670":"TL","228":"TG","690":"TK","676":"TO","1868":"TT","216":"TN","90":"TR","993":"TM","1649":"TC","688":"TV","256":"UG","380":"UA","971":"AE","44":"GB","1":"US","598":"UY","998":"UZ","678":"VU","58":"VE","84":"VN","681":"WF","212":"EH","967":"YE","260":"ZM","263":"ZW"}';
    const mappingData = JSON.parse(JSONMappingData);
    const countryCode = mappingData[this.props.loggedInUserDefaultCountryCode];
    if (phoneNumber === "99999999") {
      if (this.props.loggedInUserDefaultCountryCode === "61") {
        this.setState({ maskValue: ("09 9999 9999") });
        return phoneNumber;
      }
    } else {
      const phoneNumber1 = parsePhoneNumber(phoneNumber, countryCode);
      if (phoneNumber1) {
        this.setState({ PhoneNumber: phoneNumber1.nationalNumber })
        if (phoneNumber1.isValid() === true) {
          this.setState({
            phoneNumber: phoneNumber1.number
          });
          this.maskValue(this.state.PhoneNumber)
          return phoneNumber1.format("E.164");
        } else {
          this.setState({ PhoneNumber: phoneNumber })
          this.setState({ phoneNumber: "" })
          return phoneNumber;
        }
        return phoneNumber;
        this.setState({ phoneNumber: "" })
      }
      else {
        this.setState({ PhoneNumber: phoneNumber })
      }
    }
  }
  validEmail = (e: any) => {
    var emailChecker = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var emailtest = e.target.value;
    var validateEmail = emailChecker.test(emailtest);

    this.setState({ email: e.target.value });

    if (!validateEmail && e.target.value !== "") {
      this.setState({
        emailErrors: true,
      });
    } else {
      this.setState({
        emailErrors: false,
      });
    }
  };
  render() {
    const toReturn = [];
    let companyVersion=store.getState().reduxReducer.companyVersion;
    let tagSuggestions;
      if(companyVersion===2)
        {
     tagSuggestions = this.props.yakChatGroupData && this.props.yakChatGroupData.map((i: any, x: number) => {
      return { label: i?.Name, value: i?.InboxId };
      
    });
  }
  else
  {
    
     tagSuggestions = this.props.yakChatGroupData && this.props.yakChatGroupData.map((i: any, x: number) => {
      return { label: i?.UserName, value: i?.UserName };
      
    });
  }
    toReturn.push(
      <div className="right_Sec" key={1} id="right_Sec_main">
        <div className="top_row">
          <div className="top_left">
            <div className="usr_imgcon" style={{ maxWidth: "58vw" }}>
              <a
                href="javascript:;void(0);"
                className="left_arrow"
                onClick={() => {
                  commonMethod.hideLeftSection();
                  setTimeout(() => { document.getElementById("contacts_tab")?.click(); }, 200);
                }}
              >
                <BackIcon id="newMessage-backArrow" className="blk_icon" />
              </a>
              <div className="usr_imgbx">
                <div
                  className="usr_img2"
                  style={{ backgroundColor: this.props.contactSelected_OpenContact.avatarColor }}
                >
                  {commonMethod.generateFirstLastNameIntials(this.state.firstName && this.state.lastName ? (this.state.firstName ? this.state.firstName : "") + " " + (this.state.lastName !== null ? this.state.lastName : "") : this.state.displayname)}
                </div>
              </div>
              <div className="usr_txt">
                <h3>{this.state.firstName || this.state.lastName?.replace(/["]/g, "") ?
                 (this.state.firstName ? this.state.firstName : "") + " "
                 + (this.state.lastName!=null&&this.state.lastName!=undefined?this.state.lastName:"") : this.state.phoneNumber}</h3>
              </div>
            </div>
          </div>
          {this.props.contactSelected_OpenContact.type === "YakChat" ? (
            <div className="top_right d-flex">
              <a
                href="javascript:;void(0);"
                className={`more_icon ${this.props.editing ? "ylw_bg" : ""} crcl_icon togl_btn`}
                id=""
                onClick={() => {
                  this.setState({ temporarySharedWith: this.state.sharedWith });
                  if (this.state.firstName != "") {
                    this.setState({ nameErrors: false });
                  }
                  if (this.state.phoneNumber != "") {
                    this.setState({ showErrors: false });
                  }
                  this.props.setTabOpened(this.props.editing ? "contactopen" : "contactedit");
                }}
              >
                <EditImage className="blk_icon"></EditImage>
              </a>
              <a
                href="javascript:;void(0);"
                id=""
                className={`more_icon ${this.state.dialogBox == "delete" ? "ylw_bg" : ""
                  } crcl_icon outln_btn`}
                onClick={() => this.setState({ dialogBox: "delete" })}
              >
                <DeleteImage className="blk_icon"></DeleteImage>
              </a>
              <a
                href="javascript:;void(0);"
                className={`more_icon crcl_icon togl_btn ${this.props.infoPanelOpened ? "ylw_bg" : ""
                  }`}
                id="show_info"
                style={{
                  transition: "background 1s",
                }}
                onClick={(event: any) =>
                  this.props.setInfoPanelOpened(!this.props.infoPanelOpened)
                }
              >
                <DotsIcon className="blk_icon" />
              </a>
            </div>
          ) : (
            <div className="top_right d-flex">
              <a
                href="javascript:;void(0);"
                className={`more_icon crcl_icon togl_btn ${this.props.infoPanelOpened ? "ylw_bg" : ""
                  }`}
                id="show_info"
                style={{ transition: "background 1s" }}
                onClick={(event: any) => this.props.setInfoPanelOpened(!this.props.infoPanelOpened)}
              >
                <DotsIcon className="blk_icon" />
              </a>
            </div>
          )}
        </div>
        <div className="chat_or_info">
          <div className="chat_sec">
            <div className="chat_bx">
              <div className="cntct_frm cntc_open">
                <form style={{ textAlign: "left" }}>
                  <>
                    <div className="mb-3">
                      <label className="form-label grry_txt">
                        First name {this.props.editing ? <span> *</span> : ""}
                      </label>
                      <input
                        type="text"
                        maxLength={50}
                        required
                        disabled={!this.props.editing}
                        className={this.state.nameErrors ? this.props.editing ? "form-control-error form-control" : "form-control no_editing" : `form-control ${this.props.editing ? "" : "no_editing"}`}
                        placeholder="First name"
                        value={this.state.firstName || ''}
                        onChange={this.handleInput}
                      />
                      {this.state.nameErrors ? (
                        <span className="error-div">
                          <ErrorIcon
                            className={
                              this.props.editing ? "error-icon" : "hide-error"
                            }
                          />{" "}
                          <span className={this.props.editing ? "error-span" : "hide-error"}
                          >
                            "Please enter a valid name"
                          </span>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Last name</label>
                      <input
                        required
                        type="text"
                        disabled={!this.props.editing}
                        className={`form-control ${this.props.editing ? "" : "no_editing"
                          }`}
                        placeholder="Last name"
                        value={this.state.lastName?.replace(/["]/g, "") || ''}
                        onChange={(e) =>
                          this.setState({ lastName: e.target.value })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        PHONE NUMBER {this.props.editing ? <span> *</span> : ""}
                      </label>
                      <InputMask
                        className={this.state.showErrors ? this.props.editing ? "form-control-error form-control" : "form-control no_editing" : `form-control ${this.props.editing ? "" : "no_editing"}`}
                        disabled={!this.props.editing}
                        onChange={this.validatePhoneNumber}
                        onCut={() => {
                          this.setState({ maskValue: "", PhoneNumber: "", phoneNumber: "" });
                        }}
                        mask={this.state.maskValue}
                        placeholder={"Phone Number"}
                        value={this.state.PhoneNumber}
                        //  onFocus={() =>this.setState({ maskValue: null })}
                        onKeyDown={(event: any) => {
                          if (event.keyCode == 8 || event.keyCode == 46) {
                            this.setState({ maskValue: null })
                          }
                        }}
                      />
                      {/* <PhoneInput
                        value={ this.state.PhoneNumber|| ''}
                        inputClass={this.state.showErrors ? this.props.editing ? "form-control-error form-control" : "form-control no_editing" : `form-control ${this.props.editing ? "" : "no_editing"}`}
                        placeholder={"Phone Number"}
                        masks={this.props.loggedInUserDefaultCountryCode === 44 ? {"gb":"(.).... ......" }: this.props.loggedInUserDefaultCountryCode === 1 ? {"us":'(...) ...-....'} :{"au" :'(..) .... ....'}}
                        // defaultMask={this.props.loggedInUserDefaultCountryCode === 44 ? "..... ......" : this.props.loggedInUserDefaultCountryCode === 1 ? '(...) ...-....' : '.. .... ....'}
                        disableDropdown={true}
                        country={this.props.loggedInUserDefaultCountryCode === 44 ? 'gb' : this.props.loggedInUserDefaultCountryCode === 1 ? 'us' : 'au'}
                        specialLabel={""}
                        disableCountryGuess={this.state.PhoneNumber !== null && this.state.PhoneNumber !== undefined ?this.state.PhoneNumber.startsWith('+')?false:true:true}
                        disableCountryCode={this.state.PhoneNumber !== null && this.state.PhoneNumber !== undefined ?this.state.PhoneNumber.startsWith('+')?false:true:true}
                        alwaysDefaultMask={true}
                        enableLongNumbers={false}
                        disabled={!this.props.editing}
                        onChange={(value: any, country: any, e: any, formattedValue: any) => {
                         if(e.target.value.startsWith('+')){
                            var numberdata= e.target.value.replace(/ /g,'');
                            this.setState({  PhoneNumber:numberdata,phoneNumber: numberdata })  
                          }
                          else 
                          {   
                            if (value.startsWith(this.props.loggedInUserDefaultCountryCode)) {
                            var parseNumber = parsePhoneNumber('+' + value, country.countryCode);
                          } 
                           else {
                            var parseNumber = parsePhoneNumber('+' + this.props.loggedInUserDefaultCountryCode + value, country.countryCode);
                          }
                          if(parseNumber){                          
                            this.setState({ phoneNumber: parseNumber?.number,PhoneNumber: ( this.props.loggedInUserDefaultCountryCode  === 44 ||  this.props.loggedInUserDefaultCountryCode  === 61) ? '0' + parseNumber?.nationalNumber : parseNumber?.nationalNumber })
                          }else{
                            this.setState({PhoneNumber: value })

                          }}
                        }
                      }
                      onKeyDown={(event:any)=>{
                      if(event.keyCode == 8 && event.target.value == "+"){
                           this.setState({PhoneNumber : ""})
                      }}}
                      ></PhoneInput> */}
                      {this.state.showErrors ? (
                        <span className="error-div">
                          <ErrorIcon className={this.props.editing ? "error-icon" : "hide-error"}
                          />{" "}
                          <span className={this.props.editing ? "error-span" : "hide-error"}
                          >
                            {this.state.showError}
                          </span>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mb-3"

                    >
                      <label className="form-label">E-MAIL ADDRESS</label>
                      <input
                        required
                        disabled={!this.props.editing}
                        type="email"
                        className={this.state.emailErrors ? this.props.editing ? "form-control-error form-control" : "form-control no_editing" : `form-control ${this.props.editing ? "" : "no_editing"}`}
                        placeholder="E-mail Address"
                        value={this.state.email?.replace(/["]/g, "") || ''}
                        onChange={this.validEmail}
                      />
                      {this.state.emailErrors ? (
                        <span className="error-div">
                          <ErrorIcon
                            className={this.props.editing ? "error-icon" : "hide-error"}
                          />{" "}
                          <span
                            className={this.props.editing ? "error-span" : "hide-error"}
                          >
                            Please Enter Valid Email
                          </span>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    {this.props.contactSelected_OpenContact.type ===
                      "YakChat" &&
                      (this.props.editing ? (
                        this.props.ServicePlanId === 1 || this.props.ServicePlanId === 3 ? "" : (
                          <div className="mb-3">
                            <label className="form-label">Shared with</label>
                            {tagSuggestions && (
                              this.state.sharedWith?
                                <Select
                                  className="sharedwith-dropdown"
                                  mode="multiple"
                                  defaultActiveFirstOption={false}
                                  defaultValue={this.state.sharedWith}
                                  value={this.state.sharedWith}
                                  placeholder="Start typing inbox name..."
                                  onChange={this.handleChange}
                                  filterOption={(v, option) => {
                                    v = v.toLowerCase();
                                    const a: any = option;
                                    return (a?.label?.toLowerCase().includes(v) || a?.value?.toLowerCase().includes(v));
                                  }}
                                  style={{ width: "100%", }}
                                  options={tagSuggestions}
                                >
                                </Select> :
                                <Select
                                  className="sharedwith-dropdown"
                                  mode="multiple"
                                  defaultActiveFirstOption={false}
                                  placeholder="Start typing inbox name..."
                                  onChange={this.handleChange}
                                  filterOption={(v, option) => {
                                    v = v.toLowerCase();
                                    const a: any = option;
                                    return (a?.label?.toLowerCase().includes(v) || a?.value?.toLowerCase().includes(v));
                                  }}
                                  style={{ width: "100%", }}
                                  options={tagSuggestions}
                                >
                                </Select>
                            )}
                          </div>)
                      ) : (
                        this.props.ServicePlanId === 1 || this.props.ServicePlanId === 3 ? "" : (
                          <div className="mb-3">

                            <label className="form-label">SHARED WITH</label>
                            <input
                              disabled={true}
                              type="text"
                              className={`form-control ${this.props.editing ? "" : "no_editing"}`}
                              placeholder="Shared With"
                              value={this.state.sharedWith}
                              onChange={
                                this.handleSharedWith
                              }
                            />
                          </div>)
                      ))}
                      {this.props.contactSelected_OpenContact.type ===
                      "YakChat" &&
                      (this.props.editing ? null : (
                        this.props.ServicePlanId === 1 || this.props.ServicePlanId === 3 ? "" : (
                          this.state.sharedWith?.replace(/["]/g, "") !== "" ?
                          (
                          <div className="mb-3">
                            <label className="form-label">CONTACT OWNER</label>
                            <input
                              disabled={true}
                              type="text"
                              className={`form-control ${this.props.editing ? "" : "no_editing"}`}
                              placeholder="CONTACT OWNER"
                              value={this.state.contactOwner}                            
                            />
                          </div>) :null
                        )
                      ))}
                  </>
                </form>
              </div>
            </div>

            <div className="msg_txtbx justify-content-end align-items-center">
              {this.props.editing ? (
                <>
                  <button className="btn cstm_btn blk_btn cancelbtn" onClick={() => this.setState({ dialogBox: "cancel" })}> Cancel </button>
                  <button className="btn cstm_btn ylo_btn" onClick={this.saveContact}>Save Contact</button>
                </>
              ) : this.props.ServicePlanId === 1 || this.props.ServicePlanId === 3 ? (
                <div className="mobile_send_btn">
                  <Button
                    className={this.state.activebutton ? "btn-send-focus" : "btn-sends"}
                    startIcon={
                      <SendIcon
                        fill="var(--surface)"
                        height={20}
                        width={20}
                      ></SendIcon>
                    }
                    onClick={(e) => { this.SendMessage(); }}
                  >
                    Send message
                  </Button>
                </div>
              ) : this.props.sharedinboxData?.other?.length === 1 ? (
                <div className="mobile_send_btn">
                  <Button className={this.state.activebutton ? "btn-send-focus" : "btn-sends"}
                    startIcon={
                      <SendIcon
                        fill="var(--surface)"
                        height={20}
                        width={20}
                      ></SendIcon>
                    }
                    onClick={(e) => { this.SendMessageBySingleSharedInbox(); }}
                  >
                    Send message
                  </Button>
                </div>
              ) : (
                <div className="mobile_send_btn">
                  <Button
                    className={this.state.activebutton ? "btn-send-focus" : "btn-sends"}
                    startIcon={
                      <SendIcon
                        fill="var(--surface)"
                        height={20}
                        width={20}
                      ></SendIcon>
                    }
                    onClick={(e) => {
                      this.setState({ dialogBox: "SendMessage" });
                    }}
                  >
                    Send message
                  </Button>
                </div>
              )}
            </div>
          </div>
          <Drawer
            className={
              this.props.infoPanelOpened ? "Drawer" : "Drawer Drawer-Open"
            }
            classes={{ paper: "MuiDrawer-paper2" }}
            variant="persistent"
            anchor="right"
            elevation={1}
            open={this.props.infoPanelOpened}
          >
            <div className="info_sec" style={{ left: "0px" }}>
              <div className="cntct_profile text-center"
              >
                <div className="profl_img usr_img2" style={{ backgroundColor: this.props.contactSelected_OpenContact.avatarColor }}>
                  {commonMethod.generateFirstLastNameIntials(this.state.firstName || this.state.lastName ? (this.state.firstName ? this.state.firstName : "") + " " + (this.state.lastName ? this.state.lastName : "") : this.state.phoneNumber)}
                </div>
                <div className="phone_txt">
                  {" "}
                  {this.state.firstName || this.state.lastName ? (this.state.firstName ? this.state.firstName : "") + " " + this.state.lastName!=null&&this.state.lastName!=undefined?this.state.lastName:""  : this.state.phoneNumber}{" "}
                </div>
              </div>

              <div className="cntct_info cntct_open pdb_15 contact_accordions">
                <Collapse
                  defaultActiveKey={["3"]}
                  expandIconPosition={"right"}
                  expandIcon={({ isActive }) => (
                    <DownArrow rotate={isActive ? 180 : 0} />
                  )}
                >
                  <Panel
                    className="grey_hedln"
                    header={
                      <p className="grey_hedln">
                        Messages with{" "}
                        {this.state.firstName || this.state.phoneNumber}
                      </p>
                    }
                    key="1"
                  >
                    <div className="contact_empty"></div>
                  </Panel>
                  <Panel
                    className="grey_hedln"
                    key="2"
                    header={
                      <p className="grey_hedln">
                        Contact groups with{" "}
                        {this.state.firstName || this.state.phoneNumber}
                      </p>
                    }
                  >
                    <div>
                      {/* <ul className="cntct_grps">
                        {this.props.yakchatLists && this.props.yakchatLists.map((c: any) => {
                          console.log("ccccc", c)
                          var GetGrouplistcontact = "";
                          if ((c.Id || c.Id === 0) && c.localContacts.$values?.length > 0)
                            GetGrouplistcontact = c.localContacts?.$values?.filter((x: any) => x.ContactId === this.state.contactId);
                          if (GetGrouplistcontact?.length > 0)
                            return (
                              (c.Id || c.Id === 0) && (
                                <li className="contactOpen-sidePanel-GroupNames"
                                  onClick={(e) => {
                                    this.props.setGroupCurrentlyEditing(c);
                                    this.props.setSelectedContacts(c.localContacts.$values);
                                    console.log("ccccc", c)
                                    this.props.setTabOpened("");
                                    this.props.setTabOpened("viewgroup");

                                    this.props.setInfoPanelOpened(false);
                                  }}
                                >
                                  <span className="cl_lft">
                                    <span className="left_Bx">
                                      <span className="grp_bx">
                                        {commonMethod.generateFirstLastNameIntials(c.ListName)}
                                      </span>
                                      <span className="grp_bx_txt">
                                        {c.ListName}
                                        <span className="grry_txt">
                                          {c.localContacts?.$values?.length}{" "}
                                          Contacts
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </li>
                              )
                            );
                        })}
                      </ul> */}
                    </div>
                  </Panel>
                  <Panel
                    key="3"
                    header={<p className="grey_hedln">Contact actions</p>}
                    className="grey_hedln"
                  >
                    <ul className="optn_list">
                      {this.props.ServicePlanId === 1 ||
                        this.props.ServicePlanId === 3 ? (
                        <li className="group_action-li">
                          {" "}
                          <a
                            href="javascript:;void(0);"
                            title="Send message to contact"
                            onClick={(e) => { this.SendMessage(); }}
                          >
                            {" "}
                            <span>
                              <SendIcon className="blk_icon" />
                            </span>
                            Send message to contact{" "}
                          </a>{" "}
                        </li>
                      ) : this.props.sharedinboxData?.other?.length === 1 ? (
                        <li className="group_action-li">
                          {" "}
                          <a
                            href="javascript:;void(0);"
                            title="Send message to contact"
                            onClick={(e) => { this.SendMessageBySingleSharedInbox(); }}
                          >
                            {" "}
                            <span>
                              <SendIcon className="blk_icon" />
                            </span>
                            Send message to contact{" "}
                          </a>{" "}
                        </li>
                      ) : (
                        <li className="group_action-li">
                          {" "}
                          <a
                            href="javascript:;void(0);"
                            title="Send message to contact"
                            onClick={(e) => {
                              this.setState({ dialogBox: "SendMessage" });
                            }}
                          >
                            {" "}
                            <span>
                              <SendIcon className="blk_icon" />
                            </span>
                            Send message to contact{" "}
                          </a>{" "}
                        </li>
                      )}
                      {this.props.contactSelected_OpenContact.type ===
                        "YakChat" && (
                          <li
                            className={`${this.state.dialogBox == "addToGroup group_action-li" ? "active group_action-li" : "group_action-li"}`}
                          >
                            {" "}
                            <a
                              href="javascript:;void(0);"
                              title="Add contact to a group"
                              onClick={(e) => {
                                this.setState({ temporarySharedWith: this.props.yakChatGroupData && this.state.sharedWith && this.props.yakChatGroupData.find((x: any) => x.UserName == this.state.sharedWith) ? this.props.yakChatGroupData.find((x: any) => x.UserName == this.state.sharedWith).Email : "", dialogBox: "addToGroup" });
                              }}
                            >
                              {" "}
                              <span>
                                <AddToGroupIcon className="blk_icon" />
                              </span>
                              Add contact to a group{" "}
                            </a>{" "}
                          </li>
                        )}
                      {this.props.contactSelected_OpenContact.type ===
                        "YakChat" && (
                          <li
                            onClick={() => {
                              this.props.setTabOpened("");
                              this.props.setTabOpened("contactedit");
                              this.setState({ showinfo: false, temporarySharedWith: this.state.sharedWith });
                            }}
                            className="group_action-li"
                          >
                            {" "}
                            <a href="javascript:;void(0);" title="Edit contact">
                              <span>
                                <EditImage
                                  className="blk_icon"
                                  style={{
                                    fill: "var(--onsurfacehighest)",
                                    width: 33,
                                    marginLeft: -5,
                                  }}
                                ></EditImage>
                              </span>
                              Edit contact{" "}
                            </a>{" "}
                          </li>
                        )}
                      {this.props.contactSelected_OpenContact.type ===
                        "YakChat" && (
                          <li
                            onClick={(e) => this.setState({ dialogBox: "delete" })}
                            className={`${this.state.dialogBox == "delete group_action-li" ? "active group_action-li" : "group_action-li"}`}
                          >
                            <a href="javascript:;void(0);" title="Delete contact" className="red">
                              <span>
                                <DeleteImage
                                  style={{ width: 33, marginLeft: -5 }}
                                />
                              </span>
                              Delete contact
                            </a>
                          </li>
                        )}
                    </ul>
                  </Panel>
                </Collapse>
              </div>
            </div>
          </Drawer>
        </div>
      </div>
    );
    if (this.state.dialogBox == "delete")
      toReturn.push(
        <div className="dialogBox">
          <div className="addcontact_box" key={2}>
            <div className="sure_detail">
              <div className="addcont_txt">
                <h3>
                  Are you sure you want to delete {this.state.firstName}{" "}
                  {this.state.lastName !== null ? this.state.lastName : ""}?
                </h3>
                <p className="save_press">
                  You won’t be able to undo this action
                </p>
              </div>
              <div className="addgr_btnbox">
                <button
                  className="btn cstm_btn blk_btn cancelbtn"
                  onClick={() => this.setState({ dialogBox: "" })}
                >
                  {" "}
                  Cancel{" "}
                </button>
                <button
                  className="btn  cstm_btn del_btn"
                  onClick={this.deleteContact
                  }
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    else if (this.state.dialogBox == "addToGroup")
      toReturn.push(
        <div className="dialogBox">
          <div className="addcontact_box" key="AddContactsToGroup">
            <div className="addcontact_detail">
              <div className="addcont_txt">
                <h3>Add contact to group</h3>
                <p>
                  Select the group or groups you want your contact to be placed
                  in
                </p> 
             
              </div>
              <button
                type="button"
                className="pop-closebtn"
                onClick={() => this.setState({ dialogBox: "" })}
              >
                <img src="images/cross.svg" />
              </button>

              <ul className="usr_list import_contactbox add_groupbox">
                
                {this.props.yakchatLists &&
                  this.props.yakchatLists.map((c: any) => {
                    return (( c.Id ||  c.Id=== 0) && (
                      <li>
                        <div className="usr_imgbx">
                          <div className="grp_bx">
                            {commonMethod.generateFirstLastNameIntials(c.ListData !== undefined ? c.ListData.ListName  : c.ListName)}
                          </div>
                        </div>
                        <div className="usr_txt">
                          <h3 >{c.ListName !== undefined ? c.ListName : c.ListData.ListName}</h3>
                          <div className="txt_div">
                            <span className="sub_txt">
                              {c.localContacts &&
                                c.localContacts?.$values?.length}{" "}
                              Contacts
                            </span>
                          </div>
                        </div>
                        <label className="group_check">
                          <input
                            type="checkbox"
                            checked={this.state.list_Id ===  c.Id}
                            id="groupEmailSelected"
                            name="groupEmailSelected"
                            onChange={(e: any) => {
                              if (this.state.list_Id === c.Id) {
                                this.setState({ list_Id: "" });
                              } else {
                                this.setState({ list_Id:  c.Id });
                              }

                            }}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </li>
                    )
                    );
                  })}
              </ul>
              <div className="addgr_btnbox">
                <a
                  href="javascript:;void(0);"
                  className="drag_btn next_btn next_yellow add_grbtn"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.EditYakChatontact(this.state.contactId, this.state.list_Id, this.props.yakchatLists);
                    this.setState({ dialogBox: "" });
                  }}
                >
                  Add to group
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    else if (this.state.dialogBox == "cancel")
      toReturn.push(
        <div className="dialogBox">
          <div className="addcontact_box" key="cancel">
            <div className="sure_detail">
              <div className="addcont_txt">
                <h3>Are you sure you want to cancel?</h3>
                <p className="save_press">
                  If you don’t press save you will lose all the changes you have
                  made
                </p>
              </div>
              <div className="addgr_btnbox">
                <button
                  className="btn cstm_btn blk_btn cancelbtn"
                  onClick={() => { this.setState({ dialogBox: "" }); }}
                >
                  {" "}
                  Cancel{" "}
                </button>
                <button
                  className="btn  cstm_btn ylo_btn2"
                  onClick={() => {
                    this.setState({ dialogBox: "" });
                    this.props.setTabOpened("contactopen");
                  }}
                >
                  {" "}
                  Okay{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    else if (this.state.dialogBox == "SendMessage")
      toReturn.push(      
        <div className="dialogBox">
        <div className="addcontact_box" key="AddContactsToGroup">
          <div className="addcontact_detail">
            <div className="addcont_txt">
              <h3>Send Message</h3>
              <p>
                Select the Inbox you want to send your message contact to be
                placed in
              </p>
            </div>
            <button
              type="button"
              className="pop-closebtn"
              onClick={() => this.setState({ dialogBox: "" })}
            >
              <img src="images/cross.svg" />
            </button>

            <ul className="usr_list import_contactbox add_groupbox">
              {this.props.sharedinboxData.currentSelected.name !==
                "Closed" ? (
                <li>
                  <div className="usr_imgbx">
                    <div className="grp_bx">
                      {commonMethod.generateFirstLastNameIntials(this.props.sharedinboxData ? this.props.sharedinboxData.currentSelected.name : "")}
                    </div>
                  </div>
                  <div className="usr_txt">
                    <h3>
                      {" "}
                      {this.props.sharedinboxData ? this.props.sharedinboxData.currentSelected.name : ""}
                    </h3>
                    <div className="txt_div">
                      <span className="sub_txt"></span>
                    </div>
                  </div>
                  <label className="group_check">
                    <input
                      type="radio"
                      checked={this.state.SendMessageEmail === this.props.sharedinboxData.currentSelected.email}
                      id="groupEmailSelected"
                      name="groupEmailSelected"
                      onChange={(e: any) => {
                        if (this.state.SendMessageEmail === this.props.sharedinboxData.currentSelected.email) {
                          this.setState({ SendMessageEmail: "" });
                        } else {
                          this.setState({ SendMessageEmail: this.props.sharedinboxData.currentSelected.email });
                        }
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </li>
              ) : (
                ""
              )}
              {this.props.sharedinboxData?.other?.length > 0 ? this.props.sharedinboxData.other.map((x: any, i: number) => {
                if (x.email === "Closed") return null;
                return (
                  <li>
                    <div className="usr_imgbx">
                      <div className="grp_bx">
                        {commonMethod.generateFirstLastNameIntials(x.name)}
                      </div>
                    </div>
                    <div className="usr_txt">
                      <h3>{x.name}</h3>
                      <div className="txt_div">
                        <span className="sub_txt">
                        </span>
                      </div>
                    </div>
                    <label className="group_check">
                      <input
                        type="radio"
                        onChange={(e: any) => {
                          if (this.state.SendMessageEmail === x.email) {
                            this.setState({ SendMessageEmail: "" });
                          } else {
                            this.setState({ SendMessageEmail: x.email });
                          }
                        }}
                        id="groupEmailSelected"
                        name="groupEmailSelected"
                      />
                      <span className="checkmark"></span>
                    </label>
                  </li>
                );
              }
              )
                : null}
            </ul>
            <div className="addgr_btnbox d-flex justify-space-between">
              <button
                style={{
                  color: "var(--onPrimary)",
                  backgroundColor: " var(--secondary)",
                  minWidth: "90px",
                }}
                className="blk_btn drag_btn"
                onClick={() => this.setState({ dialogBox: "" })}
              >
                Cancel
              </button>
              <a
                style={{ marginLeft: "auto" }}
                href="javascript:;void(0);"
                className="drag_btn next_btn next_yellow add_grbtn"
                onClick={(e) => {
                  e.preventDefault();
                  this.SendMessageToContact(this.state.SendMessageEmail);
                  this.setState({ dialogBox: "" });
                }}
              >
                Send
              </a>
            </div>
          </div>
        </div>
      </div>   
        // <SendMessagePopup/>
      );
    return toReturn;
  }
  displayConversationsWithThisPerson(): React.ReactNode {
    return <div></div>;
  }
}
const mapStateToProps = (props: any) => {
  return {
    loggedInUserDefaultCountryCode: props.reduxReducer.loggedInUser.DefaultCountryCode,
    contactSelected_OpenContact: props.reduxReducer.contactSelected_OpenContact || [],
    yakChatGroupData: props.reduxReducer.setSharedEmails,
    infoPanelOpened: props.reduxReducer.infoPanelOpened,
    roomData: props.reduxReducer.roomData,
    yakchatList: props.reduxReducer.YakChatContactList,
    sharedinboxData: props.reduxReducer.sharedInboxData,
    ServicePlanId: props.reduxReducer.ServicePlanId,
    yakchatLists:props.reduxReducer.yakchatLists,

  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch<{}, null, any>, props: any) => {
  return {
    setSelectedContacts: (contact: any) => {
      dispatch<any>(action.setSelectedContacts(contact));
    },
    setTabOpened: (tab: string) => {
      dispatch<any>(action.setTabOpened(tab));
    },
    SetNewContactData: (contact: any) => {
      dispatch<any>(action.setnewcontactData(contact));
    },
    editOutLookContact: (id: any, data: any) => {
      dispatch<any>(action.editOutLookContact(id, data));
    },
    editAzureUsers: (id: any, data: any) => {
      dispatch<any>(action.editAzureUsers(id, data));
    },
    editSharePointContact: (id: any, data: any) => {
      dispatch<any>(action.editSharePointContact(id, data));
    },
    editYakChatContact: async (id: any, data: any) => {
     let companyVersion=store.getState().reduxReducer.companyVersion;
        if(companyVersion===2)
          {
      return dispatch<any>(action.editYakChatContact_V2(id, data));
          }
          else
          {
            return dispatch<any>(action.editYakChatContact(id, data));
          }
    },
    sendmessage: async (data: any, text: any, email: any) => {
      let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
      {
      return dispatch<any>(action.SendMessage_V2(data, text, email, null));
      }
      else
      return dispatch<any>(action.SendMessage(data, text, email, null));
    },
    EditYakChatontact: (id: any, data: any, yakChatList: any) => {
      return dispatch<any>(action.addContactsInsideLists(id, data, [], yakChatList));
    },
    deleteThisContact: (contact: any, nextContactId: any) => {
      let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
      { dispatch<any>(action.deleteThisContact_V2(contact, nextContactId));
      }
      else{
      dispatch<any>(action.deleteThisContact(contact, nextContactId));
      }
    },
    setInfoPanelOpened: (open: boolean) => {
      dispatch<any>({ type: "setInfoPanelOpened", payload: open });
    },
    setGroupCurrentlyEditing: (group: any) => {
      dispatch<any>({ type: "setGroupCurrentlyEditing", group });
    },
    CurrentSelectInbox: (data: any) => {
      dispatch<any>(action.currentSelectedInbox(data))
    },
    setContactSelected_OpenContact: (contact: any, calledFrom: any) => {
      dispatch<any>(action.setContactSelected_OpenContact({ ...contact, type: calledFrom }));
    },
    getContactsByListId: async (group: any, lists: any, calledFrom: any, previousContacts: any) => {
     let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
        {
      dispatch<any>(action.getContactsByListId_V2(group, lists, "", previousContacts))
        }
        else
        {
          dispatch<any>(action.getContactsByListId(group, lists, "", previousContacts))
        }
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactOpen);
